import { render, staticRenderFns } from "./BasePollForm.vue?vue&type=template&id=f61d489e&scoped=true&"
import script from "./BasePollForm.vue?vue&type=script&lang=js&"
export * from "./BasePollForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61d489e",
  null
  
)

export default component.exports